var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19,
    fill: "currentcolor",
    viewBox: "0 0 24 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.126 18a.77.77 0 0 1-.693-.404.8.8 0 0 1-.12-.387.74.74 0 0 1 .117-.421L11.3 3.212a.8.8 0 0 1 .308-.308.8.8 0 0 1 .391-.096q.211 0 .391.096t.308.308l7.871 13.576a.74.74 0 0 1 .117.42.8.8 0 0 1-.12.388.77.77 0 0 1-.693.404zm.324-1h15.1L12 4zM12 15.615q.261 0 .438-.177a.6.6 0 0 0 .177-.438.6.6 0 0 0-.177-.438.6.6 0 0 0-.438-.177.6.6 0 0 0-.438.177.6.6 0 0 0-.177.438q0 .261.177.438a.6.6 0 0 0 .438.177m0-2.23q.214 0 .357-.144a.49.49 0 0 0 .143-.357v-4a.48.48 0 0 0-.144-.356.49.49 0 0 0-.357-.143.48.48 0 0 0-.356.143.49.49 0 0 0-.143.357v4q0 .212.144.356a.49.49 0 0 0 .357.144"
  })));
};
export default SvgWarning;